import React from 'react';
import { Avatar } from './UI';

const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: '⌂' },
  { id: 'plants', label: 'Plant journal', icon: '◎' },
  { id: 'treemap', label: 'Tree map', icon: '⊕' },
  { id: 'costs', label: 'Costs', icon: '₤' },
  { id: 'tasks', label: 'Tasks', icon: '✓' },
  { id: 'journal', label: 'Journal', icon: '◫' },
  { id: 'settings', label: 'Settings', icon: '⚙' },
];

export default function Shell({ page, setPage, members, children }) {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <aside style={{
        width: 'var(--sidebar-width)', flexShrink: 0,
        background: 'var(--stone-900)', display: 'flex',
        flexDirection: 'column', overflowY: 'auto',
      }}>
        <div style={{ padding: '1.5rem 1.25rem 1rem' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--stone-400)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 2 }}>Koo Yong</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 16, color: 'var(--stone-50)', fontStyle: 'italic' }}>Kitchen Garden</div>
        </div>

        <nav style={{ flex: 1, padding: '0.5rem 0.75rem' }}>
          {NAV.map(item => (
            <button key={item.id} onClick={() => setPage(item.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                width: '100%', padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                background: page === item.id ? 'rgba(247,245,240,0.1)' : 'transparent',
                color: page === item.id ? 'var(--stone-50)' : 'var(--stone-400)',
                fontSize: 13, fontFamily: 'var(--font-body)',
                border: 'none', cursor: 'pointer', textAlign: 'left',
                marginBottom: 2, transition: 'all 0.15s',
                borderLeft: page === item.id ? '2px solid var(--moss-400)' : '2px solid transparent',
              }}
              onMouseEnter={e => { if (page !== item.id) e.currentTarget.style.color = 'var(--stone-200)'; }}
              onMouseLeave={e => { if (page !== item.id) e.currentTarget.style.color = 'var(--stone-400)'; }}
            >
              <span style={{ fontSize: 14, width: 18, textAlign: 'center', opacity: 0.8 }}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div style={{ padding: '1rem 1.25rem', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ fontSize: 11, color: 'var(--stone-600)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Members</div>
          {(members || []).map(m => (
            <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <Avatar initials={m.initials} color={m.color} size={26} />
              <span style={{ fontSize: 12, color: 'var(--stone-300)' }}>{m.name}</span>
            </div>
          ))}
        </div>

        <div style={{ padding: '0.75rem 1.25rem', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ fontSize: 11, color: 'var(--stone-600)' }}>TQ11 0LP · Devon</div>
        </div>
      </aside>

      <main style={{ flex: 1, overflowY: 'auto', background: 'var(--bg)' }}>
        {children}
      </main>
    </div>
  );
}
